import MovingEye from './MovingEye';

const initMovingEyes = () => { 
  let eyes = document.getElementsByClassName('moving-eye');
  for (let eye of eyes) { 
    new MovingEye(eye);
  }
}

initMovingEyes();


// WEBPACK FOOTER //
// ./ui/assets/js/MovingEye/init.js